import { useLabels, useMapStore } from "../hooks";
import { Chip } from "../primitives/Chip";

export type MeasureReadoutProps = { className?: string };

export function MeasureReadout({ className }: MeasureReadoutProps) {
  const labels = useLabels();
  const measure = useMapStore(a => a.measure);

  if (measure.mode === null && measure.summary === null) return null;

  return (
    <Chip tone="measure" icon={measure.mode === "area" ? "area" : "ruler"} className={className} data-fxmap="measure-readout" role="status" aria-live="polite">
      {measure.summary ?? labels.measureHint}
    </Chip>
  );
}
